<template>
  <b-card no-body class="mt-2">
    <b-tabs  v-model="tabIndex" pills card>
      <b-tab
        title="Tutoriais"
        class="p-2"
        @click="setBreadcrumbTabsName('Tutoriais')"
      >
        <section v-if="tabIndex === 0">
          <TutorialsAdmin></TutorialsAdmin>
        </section>
      </b-tab>

      <b-tab
        title="Vídeos de tutoriais"
        @click="setBreadcrumbTabsName('Vídeos de tutoriais')"
        class="p-2"
      >
        <section v-if="tabIndex === 1">
          <InstructionalVideos></InstructionalVideos>
        </section>
      </b-tab>

      <b-tab
        title="Mensagens de WhatsApp"
        @click="setBreadcrumbTabsName('Mensagens de WhatsApp')"
        class="p-2"
      >
        <section v-if="tabIndex === 2">
          <WhatsAppMessages></WhatsAppMessages>
        </section>
      </b-tab>

      <b-tab
        title="E-mails"
        @click="setBreadcrumbTabsName('E-mails')"
        class="p-2"
      >
        <section v-if="tabIndex === 3">
          <TagEmailAutomation></TagEmailAutomation>
        </section>
      </b-tab>
    </b-tabs>
  </b-card>
</template>
<script>
import { mapActions } from 'vuex'
import TutorialsAdmin from '../components/Tutorials/TutorialsAdmin.vue'
import InstructionalVideos from '../components/InstructionalVideos/InstructionalVideos.vue'
import TagEmailAutomation from '@/components/TagEmailAutomation/TagEmailAutomation.vue'
import WhatsAppMessages from '@/components/WhatsAppMessage/WhatsAppMessages.vue'

export default {
  name: 'TutorialsVideos',
  components: { WhatsAppMessages, TagEmailAutomation, InstructionalVideos, TutorialsAdmin },
  data(){
    return {
      tabIndex: 2
    }
  },
  async created() {
    await this.setBreadcrumbTabsName('Tutoriais')
  },
  methods: {
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb',
    }),
    setBreadcrumbTabsName(name){
      const breadcrumb = {
        page: 'Tutoriais',
        subPage: {
          name,
          active: false
        },
        tabs: []
      }
      this.setBreadcrumb(breadcrumb)
    },
  }
}
</script>
